import { ModuleWithProviders, NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule } from "@angular/forms";
import { HttpClientModule } from '@angular/common/http';

export const providers = [
    // ... your shared services here
];

@NgModule({
    imports: [
        CommonModule
    ],
    exports: [
        FormsModule,
        HttpClientModule,
    ],
    declarations: []
})

export class CoreModule {
    static forRoot(): ModuleWithProviders<CoreModule> {
        return {
            ngModule: CoreModule,
            providers: [ ...providers ]
        };
    }
}
